import React, { useState, useEffect } from 'react';
import { Search, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const SearchModal = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const searchData = [
    { title: 'AI & Machine Learning', url: '/ai-machine-learning', type: 'Service' },
    { title: 'Cloud Services', url: '/cloud-services', type: 'Service' },
    { title: 'Digital Transformation', url: '/digital-transformation', type: 'Service' },
    { title: 'Cybersecurity Solutions', url: '/cybersecurity', type: 'Service' },
    { title: 'Data & Analytics', url: '/data-analytics', type: 'Service' },
    { title: 'Banking & Financial Services', url: '/banking-financial-services', type: 'Industry' },
    { title: 'Healthcare & Life Sciences', url: '/healthcare-life-sciences', type: 'Industry' },
    { title: 'Manufacturing & Industry 4.0', url: '/manufacturing', type: 'Industry' },
    { title: 'Careers', url: '/careers', type: 'Company' },
    { title: 'About Us', url: '/about', type: 'Company' },
    { title: 'Contact', url: '/contact', type: 'Company' },
    { title: 'Insights', url: '/insights', type: 'Resources' }
  ];

  useEffect(() => {
    if (query.length > 0) {
      const filtered = searchData.filter(item =>
        item.title.toLowerCase().includes(query.toLowerCase()) ||
        item.type.toLowerCase().includes(query.toLowerCase())
      );
      setResults(filtered);
    } else {
      setResults([]);
    }
  }, [query]);

  const handleResultClick = (url) => {
    window.location.href = url;
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="search-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="search-modal"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="search-header">
              <div className="search-input-container">
                <Search size={20} />
                <input
                  type="text"
                  placeholder="Search services, industries, or resources..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  autoFocus
                />
              </div>
              <button className="search-close" onClick={onClose}>
                <X size={20} />
              </button>
            </div>
            
            {results.length > 0 && (
              <div className="search-results">
                {results.map((result, index) => (
                  <div
                    key={index}
                    className="search-result-item"
                    onClick={() => handleResultClick(result.url)}
                  >
                    <div className="result-title">{result.title}</div>
                    <div className="result-type">{result.type}</div>
                  </div>
                ))}
              </div>
            )}
            
            {query.length > 0 && results.length === 0 && (
              <div className="no-results">
                <p>No results found for "{query}"</p>
                <p>Try searching for services, industries, or company information</p>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SearchModal;